'use client';

function isPhone() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}

export { isPhone };
//# sourceMappingURL=utils.js.map
